export default "__VITE_ASSET__CH1HAoX1__"